import { useAiOdds } from "../../../hooks/useAiOdds";
import { CARD_INFO } from "../../../dataset";
import {
  PageWrapper,
  Header,
  PlayersContainer,
  ButtonContainer,
  CardBox,
  CommunityBoard,
  CommunityCards,
  FlopCards,
  TurnRiverCards,
  CardGroup,
  CardItem,
  CardWrapper,
  Overlay,
  PlayerWrapper,
  PlayerInfo,
  PlayerHand,
  Button,
  BackButton,
  CardIcon,
  CardContainer,
  CardPreview,
} from "./styles";

import { useRecoilValue } from "recoil";
import { insetState } from "../../../recoil/inset";
interface CardProps {
  card: string;
  index: number;
  onClick: (index: number) => void;
  selected: boolean;
  src: string; // Add src prop for the image
}

const Card: React.FC<CardProps> = ({ card, index, onClick, selected, src }) => {
  return (
    <CardBox onClick={() => onClick(index)} selected={selected}>
      <img src={src} alt={`card ${card}`} />
    </CardBox>
  );
};

const OddsCalcAi = () => {
  const {
    playerHand,
    flop,
    turn,
    river,
    isCardSelect,
    selectMode,
    selectedCards,
    handleCardClick,
    selectCardForPlayer,
    selectCardForFlop,
    selectCardForTurn,
    selectCardForRiver,
    clear,
    handleOverlayClick,
    handleClose,
    isIconSelect,
    setIsIconSelect,
    // AI 관련
    aiStyle,
    setAiStyle,
    aiResponse,
    isAiLoading,
    handleAiRequest,
  } = useAiOdds();
  const inset = useRecoilValue(insetState);
  return (
    <PageWrapper isApp={inset}>
      <BackButton isApp={inset} onClick={handleClose}>
        <img src="/image-web/Icon/Back_white.svg" alt="close" />
      </BackButton>
      <Header isApp={inset}>포커 AI</Header>
      <img
        className="background"
        src="/image-web/calc/calc_background.png"
        alt="background"
      />
      <CommunityBoard>
        <CommunityCards>
          <CardGroup>
            <FlopCards>
              {flop.map((hand, handIndex) => (
                <CardItem
                  isFocus={
                    selectMode?.type === "flop" &&
                    selectMode.index === handIndex
                  }
                  key={handIndex}
                  onClick={() => selectCardForFlop(handIndex)}
                >
                  {hand !== -1 ? (
                    <img src={`/image-web/card/${hand}.png`} alt="flop card" />
                  ) : (
                    <img
                      src={`/image-web/calc/card_back.png`}
                      alt="card back"
                    />
                  )}
                </CardItem>
              ))}
            </FlopCards>
          </CardGroup>
          <TurnRiverCards>
            <CardGroup>
              <CardItem
                isFocus={selectMode?.type === "turn" && selectMode.index === 0}
                onClick={() => selectCardForTurn()}
              >
                {turn !== null ? (
                  <img src={`/image-web/card/${turn}.png`} alt="turn card" />
                ) : (
                  <img src={`/image-web/calc/card_back.png`} alt="card back" />
                )}
              </CardItem>
            </CardGroup>
            <CardGroup>
              <CardItem
                isFocus={selectMode?.type === "river" && selectMode.index === 0}
                onClick={() => selectCardForRiver()}
              >
                {river !== null ? (
                  <img src={`/image-web/card/${river}.png`} alt="river card" />
                ) : (
                  <img src={`/image-web/calc/card_back.png`} alt="card back" />
                )}
              </CardItem>
            </CardGroup>
          </TurnRiverCards>
        </CommunityCards>
      </CommunityBoard>
      <ButtonContainer>
        <Button onClick={() => clear()}>초기화</Button>
        <Button
          className="purple"
          onClick={handleAiRequest}
          disabled={isAiLoading}
        >
          {isAiLoading ? "AI 분석 중..." : "AI 요청"}
        </Button>
      </ButtonContainer>
      <PlayersContainer isApp={inset}>
        <PlayerWrapper>
          <PlayerInfo>
            <div className="player">You</div>
            <PlayerHand>
              {playerHand.hands.map((hand, handIndex) => (
                <CardItem
                  isFocus={
                    selectMode?.type === "player" &&
                    selectMode.index === handIndex
                  }
                  key={handIndex}
                  onClick={() => selectCardForPlayer(handIndex)}
                >
                  {hand !== -1 ? (
                    <img
                      src={`/image-web/card/${hand}.png`}
                      alt={`player card ${handIndex}`}
                    />
                  ) : (
                    <img
                      src={`/image-web/calc/card_back.png`}
                      alt="card back"
                    />
                  )}
                </CardItem>
              ))}
            </PlayerHand>
          </PlayerInfo>

          {/* AI 성향 선택 토글 - PlayerInfo 밖으로 이동 */}
          <div
            style={{
              marginTop: "16px",
              padding: "12px",
              backgroundColor: "rgba(255, 255, 255, 0.05)",
              borderRadius: "8px",
              width: "100%",
            }}
          >
            <div
              style={{
                color: "#fff",
                fontSize: "14px",
                marginBottom: "8px",
                textAlign: "center",
              }}
            >
              AI 성향
            </div>
            <div
              style={{
                display: "flex",
                gap: "6px",
                justifyContent: "center",
                flexWrap: "wrap",
              }}
            >
              <Button
                onClick={() => setAiStyle("aggressive")}
                className={aiStyle === "aggressive" ? "purple" : ""}
                style={{
                  fontSize: "11px",
                  padding: "6px 12px",
                  minWidth: "55px",
                  height: "32px",
                }}
              >
                공격적
              </Button>
              <Button
                onClick={() => setAiStyle("balanced")}
                className={aiStyle === "balanced" ? "purple" : ""}
                style={{
                  fontSize: "11px",
                  padding: "6px 12px",
                  minWidth: "55px",
                  height: "32px",
                }}
              >
                균형
              </Button>
              <Button
                onClick={() => setAiStyle("passive")}
                className={aiStyle === "passive" ? "purple" : ""}
                style={{
                  fontSize: "11px",
                  padding: "6px 12px",
                  minWidth: "55px",
                  height: "32px",
                }}
              >
                보수적
              </Button>
            </div>
          </div>

          {/* AI 응답 텍스트 영역 */}
          <div
            style={{
              marginTop: "16px",
              padding: "16px",
              backgroundColor: "rgba(255, 255, 255, 0.1)",
              borderRadius: "8px",
              minHeight: "120px",
            }}
          >
            <div
              style={{ color: "#fff", fontSize: "14px", marginBottom: "8px" }}
            >
              AI 분석 결과
            </div>
            <div
              style={{
                color: "#fff",
                fontSize: "13px",
                lineHeight: "1.4",
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
              }}
            >
              {aiResponse || "AI 요청 버튼을 눌러 분석을 시작하세요."}
            </div>
          </div>
        </PlayerWrapper>
      </PlayersContainer>

      {isCardSelect && (
        <>
          <Overlay onClick={handleOverlayClick} />
          <CardPreview>
            {selectMode?.type !== "player" ? (
              <>
                {flop.map((hand, handIndex) => (
                  <CardItem
                    className="preview-item"
                    isFocus={
                      selectMode?.type === "flop" &&
                      selectMode.index === handIndex
                    }
                    key={handIndex}
                    onClick={() => selectCardForFlop(handIndex)}
                  >
                    {hand !== -1 ? (
                      <img
                        src={`/image-web/card/${hand}.png`}
                        alt="flop card"
                      />
                    ) : (
                      <img
                        src={`/image-web/calc/card_back.png`}
                        alt="card back"
                      />
                    )}
                  </CardItem>
                ))}
                <CardGroup>
                  <CardItem
                    className="preview-item"
                    isFocus={
                      selectMode?.type === "turn" && selectMode.index === 0
                    }
                    onClick={() => selectCardForTurn()}
                  >
                    {turn !== null ? (
                      <img
                        src={`/image-web/card/${turn}.png`}
                        alt="turn card"
                      />
                    ) : (
                      <img
                        src={`/image-web/calc/card_back.png`}
                        alt="card back"
                      />
                    )}
                  </CardItem>
                </CardGroup>
                <CardGroup>
                  <CardItem
                    className="preview-item"
                    isFocus={
                      selectMode?.type === "river" && selectMode.index === 0
                    }
                    onClick={() => selectCardForRiver()}
                  >
                    {river !== null ? (
                      <img
                        src={`/image-web/card/${river}.png`}
                        alt="river card"
                      />
                    ) : (
                      <img
                        src={`/image-web/calc/card_back.png`}
                        alt="card back"
                      />
                    )}
                  </CardItem>
                </CardGroup>
              </>
            ) : (
              <>
                {playerHand.hands.map((hand, handIndex) => (
                  <CardItem
                    className="preview-item"
                    isFocus={
                      selectMode?.type === "player" &&
                      selectMode.index === handIndex
                    }
                    key={handIndex}
                  >
                    {hand !== -1 ? (
                      <img
                        src={`/image-web/card/${hand}.png`}
                        alt={`player card ${handIndex}`}
                      />
                    ) : (
                      <img
                        src={`/image-web/calc/card_back.png`}
                        alt="card back"
                      />
                    )}
                  </CardItem>
                ))}
              </>
            )}
          </CardPreview>
          <CardContainer>
            <CardIcon>
              <div
                className={`icon ${isIconSelect === "heart" ? "select" : ""}`}
                onClick={() => {
                  setIsIconSelect("heart");
                }}
              >
                <img
                  src={`/image-web/calc/heart${
                    isIconSelect === "heart" ? "-select" : ""
                  }.svg`}
                  alt="heart"
                />
              </div>
              <div
                className={`icon ${isIconSelect === "space" ? "select" : ""}`}
                onClick={() => setIsIconSelect("space")}
              >
                <img
                  src={`/image-web/calc/space${
                    isIconSelect === "space" ? "-select" : ""
                  }.svg`}
                  alt="spade"
                />
              </div>
              <div
                className={`icon ${isIconSelect === "club" ? "select" : ""}`}
                onClick={() => setIsIconSelect("club")}
              >
                <img
                  src={`/image-web/calc/club${
                    isIconSelect === "club" ? "-select" : ""
                  }.svg`}
                  alt="club"
                />
              </div>
              <div
                className={`icon ${isIconSelect === "diamond" ? "select" : ""}`}
                onClick={() => setIsIconSelect("diamond")}
              >
                <img
                  src={`/image-web/calc/diamond${
                    isIconSelect === "diamond" ? "-select" : ""
                  }.svg`}
                  alt="diamond"
                />
              </div>
            </CardIcon>
            <CardWrapper>
              {CARD_INFO.map((card, index) => {
                if (isIconSelect === "heart" && (index < 26 || index > 38)) {
                  return null;
                }
                if (isIconSelect === "space" && (index < 39 || index > 51)) {
                  return null;
                }
                if (isIconSelect === "club" && (index < 0 || index > 12)) {
                  return null;
                }
                if (isIconSelect === "diamond" && (index < 13 || index > 25)) {
                  return null;
                }

                return (
                  <Card
                    key={index}
                    card={card}
                    index={index}
                    onClick={() => handleCardClick(index)}
                    selected={selectedCards.includes(index)}
                    src={`/image-web/card/${index}.png`}
                  />
                );
              })}
            </CardWrapper>
          </CardContainer>
        </>
      )}
    </PageWrapper>
  );
};

export default OddsCalcAi;
